export default __webpack_public_path__ + "static/media/bg-xl.1280f42c.png";